import React from "react";
import { Formik } from 'formik';
import Button from '@mui/material/Button';
import {post} from "bloggers-backend/lib/client";
import { TextField } from "../components/forms/TextField";
import { Form } from "../components/forms/Form";
import { Alert } from "@mui/material";

export const ResetPassword = () => {
  return <Formik
    initialValues={{ email: '' }}
    onSubmit={async (values, actions) => {
      const result = await post('/auth/reset-password', values);

      if (result.success) {
        actions.setStatus({severity: 'success', text: 'Check your email for a link to reset your password.'});
      } else {
        actions.setStatus({severity: 'warning', text: result.reason});
        actions.setErrors(result.errors);
        actions.setSubmitting(false);
      }
    }}
  >
    {({ status }) => (
      <Form>
        {status ? <Alert severity={status.severity}>{status.text}</Alert> : <></>}

        {status && status.severity === 'success'
          ? <></>
          : <>
            <TextField name="email" label="email"/>

            <Button
                variant="contained"
                type="submit">Reset password
            </Button>
            </>
          }
      </Form>
    )}
  </Formik>
};
